module.exports = (__webpack_require__("2pFd"))("v6+u");